import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { Table, TableModule } from 'primeng/table';
import { Clinic } from 'src/app/models/clinic.model';
import { Visit } from 'src/app/models/visit.model';
import { DateFormatVisitPipe } from 'src/pipes/date-format-visit.pipe';

@Component({
  selector: 'visits-table',
  standalone: true,
  imports: [TableModule, DateFormatVisitPipe, InputTextModule, ButtonModule],
  templateUrl: './visit-table.component.html',
  providers: [DateFormatVisitPipe],
})
export class VisitsTableComponent implements OnInit {
  @Input()
  data: Visit[];

  @Input()
  clinic: Clinic;

  cols: any[];

  visit: Visit;
  viewModal: boolean = false;

  constructor(private dateFormatVisitPipe: DateFormatVisitPipe) {}

  ngOnInit(): void {
    this.cols = [
      { field: 'specialist.name', header: 'Especialista' },
      { field: 'patient.name', header: 'Nombre usuario' },
      { field: 'patient.apellidos', header: 'Apellidos usuario' },
      { field: 'pet.especie', header: 'Especie de mascota' },
      { field: 'pet.name', header: 'Nombre de mascota' },
      { field: 'pet.raza', header: 'Raza de mascota' },
      { field: 'pet.gender', header: 'Género de mascota' },
      { field: 'specialist.specialty', header: 'Especialidad' },
      { field: 'date', header: 'Fecha' },
    ];
  }

  view(visit: Visit) {
    this.visit = { ...visit };
    this.viewModal = true;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  exportFunction = (col: any) => {
    if (col.field === 'date') {
      return this.dateFormatVisitPipe.transform(col.data);
    }
    return col.data;
  };
}
